import ReservationForm from "../components/reservation/reservationform";
const Reservation = () => {
    return (
        <div>
            <div>
                <h1 className="text-3xl font-bold my-16 text-center text-white">
                    Reservierungsanfrage
                </h1>
            </div>
            <ReservationForm />
        </div>
    );
};

export default Reservation;
